<template>
  <div id="domain-renew">
    <form id="renew-domain-form" @submit.prevent="submitForm">
      <div class="row">
        <div class="small-12 medium-5 columns">
          <label for="period">{{ 'Period'|t }}</label>
          <div class="input-group">
            <input type="number" min="1" max="10" id="period" v-model="period" required="required" class="text-center input-group-field" />
            <span class="input-group-label">{{ 'years'|t }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="small-12 medium-5 columns">
          <input type="submit" name="submit" :value="'Renew'|t" class="medium expanded success button" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'RenewForm',
    props: {
      domain: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        period: 1,
      }
    },
    methods: {
      submitForm() {
        let request = {
          domain: this.domain,
          period: parseInt(this.period),
        };

        api.renewDomain(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Domain %s has been renewed and will expire on %s.",
              args: [data.domain, this.$options.filters.date(data.new_expiration_date, 'date')]
            }, {root: true});
            router.push({name: 'domain.collection'});
          }
        );
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/domain/Renew.vue